<section class="page">
  <h2>Classes composants</h2>

  @if (showCreateSection) {
    <form class="panel" (ngSubmit)="createClasse()">
      <h3>Créer une classe</h3>
      <label for="nouvelle-classe">Nom</label>
      <input id="nouvelle-classe" name="nouveauNom" [(ngModel)]="nouveauNom" maxlength="100" required />
      <button type="submit" [disabled]="loading">Créer</button>
    </form>
  }

  @if (showEditSection) {
    <form class="panel" (ngSubmit)="renameClasse()">
      <h3>Modifier une classe</h3>
      <label for="select-classe">Classe</label>
      <select id="select-classe" name="selectedId" [(ngModel)]="selectedId" (ngModelChange)="onSelectChange()">
        <option value="">-- sélectionner --</option>
        @for (classe of classes; track classe.id) {
          <option [value]="classe.id">{{ classe.nom }}</option>
        }
      </select>

      <label for="nom-edition">Nouveau nom</label>
      <input id="nom-edition" name="nomEdition" [(ngModel)]="nomEdition" maxlength="100" required />

      @if (pageMode === 'gerer') {
        <div class="actions">
          <button type="submit" [disabled]="loading">Enregistrer</button>
          <button type="button" class="danger" (click)="deleteClasse()" [disabled]="loading || !selectedId">Supprimer</button>
        </div>
      } @else {
        <button type="submit" [disabled]="loading">Enregistrer</button>
      }
    </form>
  }

  @if (showListSection) {
    <section class="panel">
      <h3>Liste des classes</h3>
      @if (loadingList) {
        <p>Chargement des classes...</p>
      } @else if (classes.length === 0) {
        <p>Aucune classe disponible.</p>
      } @else {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nom</th>
                @if (showDeleteActionsInTable) {
                  <th>Actions</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (classe of classes; track classe.id) {
                <tr>
                  <td>{{ classe.id }}</td>
                  <td>{{ classe.nom }}</td>
                  @if (showDeleteActionsInTable) {
                    <td class="actions-cell">
                      <button
                        type="button"
                        class="danger"
                        [disabled]="loading || deletingClassId === classe.id"
                        (click)="deleteClasseRow(classe)"
                      >
                        {{ deletingClassId === classe.id ? 'Suppression...' : 'Supprimer' }}
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
  }

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }
</section>
